import React, { useState } from "react";

export const SelectShader = ({ setFragShader }) => {
  const [btnClicked, setBtnClicked] = useState(false);
  return (
    <>
      <div className="absolute flex flex-col items-center bottom-12 lg:top-12 w-fit h-fit mx-auto lg:right-1/3 lg:px-0 px-6 text-[12px] lg:text-[18px] font-[raleway]">
        <div
          onClick={() => {
            setBtnClicked(!btnClicked);
          }}
          className={`relative flex items-center justify-center ${
            btnClicked ? "lg:w-[160px] w-[140px]" : "w-[120px]"
          }  text-center font-[raleway] font-extralight cursor-pointer h-[30px] lg:h-[40px] border-[0.5px] border-white hover:bg-white hover:text-black hover:border-blue-300 transition-all duration-500`}
        >
          SHADERS{" "}
          <p
            className={`absolute py-1 px-3 rounded-full hover:border-[0.5px] right-2 transition-all leading-none ${
              btnClicked ? "opacity-100 hover:border-black" : "opacity-0"
            }`}
          >
            x
          </p>
        </div>
        {/* {btnClicked && ( */}
        <div
          className={`flex justify-center gap-10 lg:text-[16px] font-[raleway] opacity-0 pointer-events-none pt-6 duration-500 transition-all ${
            btnClicked && "opacity-100  pointer-events-auto"
          }`}
        >
          <p
            className="cursor-pointer py-2 px-4 border-[0.5px] border-white rounded-sm text-center hover:bg-white hover:text-black transition-all"
            onClick={() => {
              setFragShader(1);
            }}
          >
            Lines
          </p>
          {/* <p
              className="cursor-pointer py-2 px-4 border border-white rounded-2xl text-center hover:bg-white hover:text-black transition-all"
              onClick={() => {
                setFragShader(1);
              }}
            >
              Bg grid
            </p> */}
          <p
            className="cursor-pointer py-2 px-4 border-[0.5px] border-white rounded-sm text-center hover:bg-white hover:text-black transition-all"
            onClick={() => {
              setFragShader(2);
            }}
          >
            Text
          </p>
          <p
            className="cursor-pointer py-2 px-4 border-[0.5px] border-white rounded-sm text-center hover:bg-white hover:text-black transition-all"
            onClick={() => {
              setFragShader(0);
            }}
          >
            Flow
          </p>
        </div>
        {/* )} */}
      </div>
    </>
  );
};
